module.exports = __webpack_public_path__ + "img/section-header-circle-visual.73eab42.svg";